/**
 * @param {String} mfeName - The MFE name. Can be "mfe-name" or "mfe-name@1.0.1" for example.
 * @param {String[]} deps - The list of MFEs registered in the host.
 * @param {String} hostName - The host name (MFE that is requesting MFE).
 */
export default function mfeDepsVersionValidator(mfeName, deps, hostName) {
  const [name, version = 'latest'] = mfeName.split('@')
  const filteredDeps = deps.filter(dep => dep.startsWith(`${name}@`))
  const hasSomeVersionCompliant =
    filteredDeps.indexOf(`${name}@${version}`) !== -1

  const errorMessage = `Check the mfeDependencies[] key in the front-hub.config.js file of micro frontend ${hostName}.`
  const filteredDepsAsString = JSON.stringify(filteredDeps)

  if (!filteredDeps.length) {
    return {
      error: `MFE ${mfeName} not found with a valid version. ${errorMessage}`,
    }
  }

  if (!hasSomeVersionCompliant && version !== 'latest') {
    return {
      error: `Requested MFE ${mfeName} is different from the found mfeDependencies: ${filteredDepsAsString}. ${errorMessage}`,
    }
  }

  if (filteredDeps.length > 1 && !hasSomeVersionCompliant) {
    return {
      error: `Found multiple dependencies for MFE ${mfeName}, identify which version from: ${filteredDepsAsString}. ${errorMessage}`,
    }
  }

  return {}
}
